module.exports = __webpack_public_path__ + "img/Speaker=Jazz Rossi.d1ea4cbf.png";